/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, bool, array } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import MessageList from 'components/MessageList/MessageList';
import Message from 'components/Message/Message';

import styles from './inbox.scss';

/**
 * This is the Inbox component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class Inbox extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: shape({
      is_client: bool,
    }).isRequired,
    messages: shape({
      loading: bool.isRequired,
      items: array.isRequired,
    }).isRequired,
  };

  /**
   * Render Inbox.
   *
   * @return {Object}
   */
  render() {
    const {
      user: { is_client },
      messages: { loading, items },
    } = this.props;

    return (
      <section className={styles.wrapper}>
        <div className={styles.content}>

          {!loading && items.length <= 0 && (
            <p className={styles.text}>
              {is_client
                ? p.t('inbox.no_messages.client')
                : p.t('inbox.no_messages.talent')}
            </p>
          )}

          <div className={styles.row}>
            <div className={styles.menu}>
              <MessageList />
            </div>
            <div className={styles.message}>
              <Message />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default connect(({ user, messages }) => ({ user, messages }))(Inbox);
